import React from "react";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ls from "local-storage";
import Grid from "@mui/material/Grid";

import orderDefaultListView from "../helpers/orderDefaultListView";
import { CustomDialogTitle } from "../components/Keyword/ListSelectable";

const TOGGLE_VIEW = "TOGGLE_VIEW";
const LOAD_CACHE = "LOAD_CACHE";

const initialState = orderDefaultListView;
export const store = React.createContext(initialState);
const { Provider } = store;

export const StateProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer((state, action) => {
    switch (action.type) {
      case TOGGLE_VIEW:
        return {
          ...state,
          ...action.payload,
        };
      case LOAD_CACHE:
        return { ...action.payload };
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

const SelectableFields = () => {
  const [open, setOpen] = React.useState(false);
  const { state: listView, dispatch } = React.useContext(store);

  React.useEffect(() => {
    const cache = ls.get("listView");
    if (cache) {
      dispatch({ type: LOAD_CACHE, payload: cache });
    }
  }, [dispatch]);

  const onToggleHandler = React.useCallback(
    (e) => {
      dispatch({
        type: TOGGLE_VIEW,
        payload: { [e.target.name]: !listView[e.target.name] },
      });
    },
    [dispatch, listView]
  );

  const handleClickOpen = () => setOpen(true);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    ls.set("listView", listView);
  }, [listView]);

  const keys = Object.keys(listView);

  const handleResetDefault = React.useCallback(() => {
    dispatch({
      type: LOAD_CACHE,
      payload: initialState,
    });
  }, [dispatch]);

  return (
    <>
      <Button color="primary" onClick={handleClickOpen}>
        <ViewColumnIcon />
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="list-selectable-dialog-title"
        open={open}
      >
        <CustomDialogTitle onClose={handleClose}>
          Customize List View
        </CustomDialogTitle>

        <DialogContent dividers>
          <Grid
            container
            spacing={3}
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
            }}
            columns={{ xs: 3, md: 9 }}
          >
            {keys.map((k) => (
              <Grid key={k} size={{ xs: 3 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={listView[k]}
                      onChange={onToggleHandler}
                      name={k}
                      color="primary"
                    />
                  }
                  label={k}
                  sx={{
                    width: "100%",
                    mr: 0,
                    ".MuiTypography-root": { textTransform: "capitalize" },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ m: 0, p: 1 }}>
          <Button onClick={handleResetDefault}>Reset default</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectableFields;
